// extracted by mini-css-extract-plugin
module.exports = {"Web3PagesRoot":"items-main_Web3PagesRoot__2hh1B","title":"items-main_title__1ZK95","text":"items-main_text__2FCSf"};